// extracted by mini-css-extract-plugin
export default {"editForm":"styles_editForm__GGkZL","editIcon":"styles_editIcon__ouuVN"};